import React from "react";
// import { Link } from "react-router-dom";
import * as paths from "../../constants/paths";

function SocialLinks({ siteSettings }) {
  return (
    <>
      <div className="social_logon">
        <a href={siteSettings.site_facebook} target="_blank" rel="noreferrer">
          <img src={paths.SITE_BASE_URL+"/images/facebok.svg"} alt="" />
        </a>
        <a href={siteSettings.site_twitter} target="_blank" rel="noreferrer">
          <img src={paths.SITE_BASE_URL+"/images/twitter.svg"} alt="" />
        </a>
        <a href={siteSettings.site_instagram} target="_blank" rel="noreferrer">
          <img src={paths.SITE_BASE_URL+"/images/instagram.svg"} alt="" />
        </a>
        <a href={siteSettings.site_linkedin} target="_blank" rel="noreferrer">
          <img src={paths.SITE_BASE_URL+"/images/linkedin.svg"} alt="" />
        </a>
      </div>
    </>
  );
}

export default SocialLinks;
